import { useTranslation } from 'react-i18next';
import {
  APPLE_STORE_URL,
  PLAY_STORE_URL
} from 'config/constants';
import { Seo, Faq } from 'ui';
import {
  Container,
  Description,
  Title,
  Wrapper,
  Text,
  BulletList,
  Link
} from './styles';



const URLS = {
  android: PLAY_STORE_URL,
  ios: APPLE_STORE_URL,
  uniswap: 'https://app.uniswap.org/#/swap?chain=mainnet&inputCurrency=ETH&outputCurrency=0xf04a8ac553fcedb5ba99a64799155826c136b0be',
  bittrex: 'https://global.bittrex.com/trade/flixx-usdt',
  bancor: 'https://app.bancor.network/trade?to=0xf04a8ac553FceDB5BA99A64799155826C136b0Be',
  mailto: 'mailto:info@flixxo.com',
}


const Faqs = () => {

  const { t } = useTranslation();

  return (
    <Container>
        <Seo title='Faqs' />

        <Wrapper>
          <Title>{t('faqs')}</Title>
          <Description>{t('answersToCommonQuestions')}</Description>


          <Faq title={t('whatIsFlixxo')}>
            <Text>{t('whatIsFlixxo_1')}</Text>

            <Text $isBold $isWhite $mt={16}>{t('whatIsFlixxo_2')}</Text>

            <BulletList>
              <Text as='li' $mt={12}>
                {t('whatIsFlixxo_3')} 
                <Text as='span' $isWhite>
                  {t('whatIsFlixxo_4')}
                </Text>
                {t('whatIsFlixxo_5')}
              </Text>

              <Text as='li' $mt={8}>
                {t('whatIsFlixxo_6')}
              </Text>
            </BulletList>

            <Text $isWhite $isBold $mt={12}>
              {t('whatIsFlixxo_7')}
            </Text>

            <BulletList>
              <Text as='li' $mt={12}>
                {t('whatIsFlixxo_8')}
                <Text as='span' $isWhite>
                  {t('whatIsFlixxo_9')}
                </Text>
              </Text>
            </BulletList>
          </Faq>


          <Faq title={t('whatKindOfContent')}>
            <Text>{t('whatKindOfContent_1')}</Text>
            <Text $mt={16}>{t('whatKindOfContent_2')}</Text>
          </Faq>


          <Faq title={t('howDoIAccess')}>
            <Text>
              {t('howDoIAccess_1')}

              <Text as='span' $isWhite $mt={16}>
                {t('howDoIAccess_2')}
              </Text>
              <Text as='span' $isWhite>
                {' '}<Link as='a' href={URLS.android}>Android</Link>
                {' '}{t('o')}
                {' '}<Link as='a' href={URLS.ios}>iOS</Link>
              </Text>

              <Text as='span' $isWhite>
                {t('howDoIAccess_3')}
              </Text>
            </Text>
          </Faq>


          <Faq title={t('FlixxoIsFree')}>
            <Text>
              {t('FlixxoIsFree_1')}
              <Text as='span' $isWhite>{t('FlixxoIsFree_2')}</Text>
            </Text>

            <Text $mt={16}>
              {t('FlixxoIsFree_3')}
              {t('FlixxoIsFree_4')}
              {' '}<Link as='a' href={URLS.android}>Android</Link>
              {' '}{t('o')}
              {' '}<Link as='a' href={URLS.ios}>iOS</Link>
              {t('FlixxoIsFree_5')}
            </Text>
          </Faq>


          <Faq title={t('whatAreFlixx')}>
            <Text>
              {t('whatAreFlixx_1')}
            </Text>

            <BulletList>
              <Text as='li' $mt={12}>{t('whatAreFlixx_2')}</Text>
              <Text as='li' $mt={8}>{t('whatAreFlixx_3')}</Text>
              <Text as='li' $mt={8}>{t('whatAreFlixx_4')}</Text>
              <Text as='li' $mt={8}>{t('whatAreFlixx_5')}</Text>
              <Text as='li' $mt={8}>{t('whatAreFlixx_6')}</Text>
              <Text as='li' $mt={8}>
                {t('whatAreFlixx_7')}
                {' '}<Link as='a' href={URLS.uniswap}>Uniswap</Link>
                {', '}<Link as='a' href={URLS.bittrex}>Bittrex</Link>
                {', '}<Link as='a' href={URLS.bancor}>Bancor</Link>
                {t('whatAreFlixx_8')}
              </Text>
            </BulletList>

            <Text $mt={16}>
              <Link to='/flixx'>{t('whatAreFlixx_9')}</Link>
            </Text>
          </Faq>


          <Faq title={t('flixxGoToCreator')}>
            <Text>{t('flixxGoToCreator_1')}</Text>
          </Faq>


          <Faq title={t('canUploadMyContent')}>
            <Text>
              {t('canUploadMyContent_1')}
              {' '}<Link to='/be-a-creator'>Flixxo creators</Link>
            </Text>
          </Faq>


          <Faq title={t('whatFlixxoMakesDifferent')}>
            <BulletList >
              <Text as='li' >{t('whatFlixxoMakesDifferent_1')}</Text>
              <Text as='li' $mt={8}>{t('whatFlixxoMakesDifferent_2')}</Text>
              <Text as='li' $mt={8}>{t('whatFlixxoMakesDifferent_3')}</Text>
              <Text as='li' $mt={8}>{t('whatFlixxoMakesDifferent_4')}</Text>
              <Text as='li' $mt={8}>{t('whatFlixxoMakesDifferent_5')}</Text>
              <Text as='li' $mt={8}>{t('whatFlixxoMakesDifferent_6')}</Text>
            </BulletList>
          </Faq>


          {/* 
          <Faq title={t('flixxoProduces')}>
            <Text>
            {t('flixxoProduces_1')}
            <Text as='span' $isWhite>{t('flixxoProduces_2')}</Text>
            {t('flixxoProduces_3')}
            <Text as='span' $isWhite>{t('flixxoProduces_4')}</Text>
            {t('flixxoProduces_5')}
            </Text>
          </Faq> 
          */}


          <Faq title={t('whatAreCreators3')}>
            <Text>{t('whatAreCreators3_1')}</Text>
            <Text $mt={16}>{t('whatAreCreators3_2')}</Text>
          </Faq>


          <Text>
            {t('haveDoubts')}
            {' '}<Link as='a' href={URLS.mailto}>{t('faqs_contactUs')}</Link>
          </Text>
        </Wrapper>
    </Container>
  )
}

export default Faqs
